export default "<ul class=\"al-msg-center clearfix\">\n  <li class=\"dropdown\">\n    \n  </li>\n</ul>\n"